<div class='fullcontainer'>
  @if (this.isError) {
    <div class="alert alert-danger">Please complete all required fields</div>
  }
  @if (this.isServerError) {
    <div class="alert alert-danger">Something went wrong. Please try again later.</div>
  }
  @if (this.isSuccess) {
    <div class="alert alert-success">Container was updated successfully</div>
  }
  <div class='sheet'>
    <h1 class='header'>Edit Container - {{ this.container.name }}</h1>
    <app-audit-line [data]='this.container'></app-audit-line>
    <form (ngSubmit)='this.onSubmit()' method='post'>
      <app-container-form [container]='this.container' [containerGrades]='this.containerGrades'>></app-container-form>
      <button type="submit" class="btn btn-success">Save</button>&nbsp;
      <button type="button" class="btn btn-danger" routerLink='/containers'>Cancel</button>
    </form>
  </div>
</div>
